import type { ReasoningPreference } from '../types';
import { auth } from './firebase';

export const createChat = async (title: string, reasoningPreference: ReasoningPreference) => {
  const user = auth.currentUser;
  if (!user) throw new Error('Debes iniciar sesión para crear un chat.');
  const chatId = crypto.randomUUID();
  const token = await user.getIdToken();
  const response = await fetch('/api/chat/create', {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ chatId, title, reasoningPreference })
  });
  if (!response.ok) throw new Error('No se pudo crear el chat.');
  return chatId;
};
